<script>
import VPageCtn from "@/components/organisms/VPageCtn.vue";
import VSiteLoader from "@/components/organisms/VSiteLoader.vue";

export default {
  name: "App",
  components: {
    VPageCtn,
    VSiteLoader
  },
  mounted() {
    VPageCtn.methods.pageEnter();
  }
};
</script>

<template>
  <div id="app">
    <VPageCtn>
      <VSiteLoader />
      <main class="site-main">
        <router-view :key="$route.path" />
      </main>
    </VPageCtn>
  </div>
</template>
